export const admin_account = {
    account: 'our_dez',
    password: 'dez123321'
}



// WEBPACK FOOTER //
// ./src/data/admin_account.js